import React from 'react';
import { Link } from 'react-router-dom';
import { PageSubTitle } from 'Components/Titles';

export const SignUp = ({ subTitle, routes }) => {
  return (
    <div className="sectionFlex membershipSection">
      <div className="flexGrowOne settingsSectionLeft">
        <PageSubTitle text={subTitle} />
      </div>
      <div className="sectionFlex flexDirCol flexGrowTwo settingsSectionRight">
        <Link to={routes.signupPlans} className="blueLink signUpLink">
          Sign Up
        </Link>
      </div>
    </div>
  );
};
